import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { isMobile } from 'react-device-detect';
import Box from '@material-ui/core/Box';
import { getLiffUrl } from 'client/utils/login';
import ShareIconButton from '../ShareIconButton';
import DialogContainer from 'components/common/Dialog/DialogContainer';
import LineLiffQrCode from 'client/components/dialogLogin/LineLiffQrCode';
import { system900, system300 } from 'Mui/styles/color';
import { retrieveLineConfig } from 'utils/manipulatePartnerSponsor';
import { GLOBAL_LIFF_ID } from 'config/envVariable';
import { useSecondaryPromoSelector } from 'client/game_photoContest/hooks/useReduxSelector';
import { SHARE_CARD_IMAGE_TYPES } from 'editor/game_mgmShare/utils/constants';

const LiffShareButton = ({
    url = '',
    color = system900.color,
    variant = 'contained',
    isFetchingData,
    isEditor,
    title,
    description,
    buttonConfig,
    isPortfolioShare,
    serialNo,
    resultImageType,
    imageUrl
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const partner = useSelector(s => s.partner);
    const sponsor = useSelector(s => s.sponsor);
    const sponsorUUID = useSelector(s => s.sponsor.uuid);
    const { id: ugcPromoId } = useSecondaryPromoSelector(s => s.promo);
    const promoUUID = useSelector(s => s.promo.uuid);
    const referralShareCard = useSelector(s => s.settingStyle.referralShareCard || {});
    const { lineLoginAppLiffId } = retrieveLineConfig({ partner, sponsor });
    const liffId = lineLoginAppLiffId || GLOBAL_LIFF_ID;

    const liffUrl = url
        ? getLiffUrl({
              liffId,
              sponsorUUID,
              redirectPath: '',
              appendQsObj: {
                  promo_uuid: promoUUID,
                  referral_url: url,
                  username: referralShareCard?.fullname || '',
                  // [860t11p9w] 企業版在 liff 流程 call promo api fever-host 要自己帶上正確的 domain
                  'fever-host': window.location.host,
                  //[https://app.clickup.com/36226806/v/dc/12hhqp-20018/12hhqp-49778]]活動分享的title 和 description會依照這份doc順序帶預設值
                  ...(title ? { title } : {}),
                  ...(description ? { description } : {}),
                  ...(isPortfolioShare && buttonConfig?.bgColor
                      ? { buttonBgColor: buttonConfig.bgColor }
                      : {}),
                  ...(isPortfolioShare && buttonConfig?.textColor
                      ? { buttonTextColor: buttonConfig.textColor }
                      : {}),
                  ...(isPortfolioShare && buttonConfig?.label
                      ? { buttonText: buttonConfig.label }
                      : {}),
                  ...(resultImageType === SHARE_CARD_IMAGE_TYPES.GAME_RESULT && imageUrl
                      ? { imageUrl }
                      : {}),
                  //作品分享使用到的參數
                  isPortfolioShare: isPortfolioShare,
                  ...(isPortfolioShare && ugcPromoId ? { ugcPromoId } : {}),
                  ...(isPortfolioShare && serialNo ? { entryId: serialNo } : {})
              }
          })
        : null;

    const openQrcode = () => setIsOpen(true);
    const closeQrcode = () => setIsOpen(false);

    return (
        <>
            <DialogContainer
                title={i18n.t('label.login.open_line_liff')}
                open={isOpen}
                isFixedWindow={true}
                disableBackdrop={false}
                themeTextColor={system900.color}
                themeBgColor="#FFF"
                haveCloseIcon={false}
                isInnerDialog={true}
                onClose={closeQrcode}
                style={css`
                    text-align: center;
                    padding-bottom: 40px;
                `}
            >
                <Box
                    px={3}
                    py={2}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                >
                    <LineLiffQrCode
                        url={liffUrl}
                        description={i18n.t('label.open.scan_qrcode_line')}
                    />
                </Box>
            </DialogContainer>
            <ShareIconButton
                variant={variant}
                text="LINE"
                textColor={color}
                bgColor="#06c755"
                imageUrl="https://assets.fevercdn.com/promotion/img/line.svg"
                url={isMobile ? liffUrl : null}
                size={28}
                isExternal={isMobile}
                style={liffButtonStyle(variant)}
                onClick={!isMobile && liffUrl ? openQrcode : null}
                isFetchingData={isFetchingData}
                isEditor={isEditor}
            />
        </>
    );
};

export default LiffShareButton;

const liffButtonStyle = variant => css`
    color: ${system900.color};
    border-color: ${variant === 'outlined' ? system300.color : ''};
    padding: 10px;
`;

LiffShareButton.propTypes = {
    url: PropTypes.string,
    color: PropTypes.string,
    variant: PropTypes.string
};
